var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.title)+" "),_c('v-spacer'),_c('div',{staticClass:"health-status-indicator",class:_vm.amberStatus ? 'amber darken-3' : 'green accent-4'})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }